
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.9 24.4c0 13.4-10.9 24.3-24.5 24.3-4.3 0-8.3-1.1-11.8-3L.1 49.9l4.4-13C2.3 33.2 1 28.9 1 24.4 1 11 11.9.1 25.5.1 39 .1 49.9 11 49.9 24.4zM25.4 4C14.1 4 4.9 13.1 4.9 24.4c0 4.5 1.5 8.6 3.9 12L6.2 44l7.9-2.5c3.2 2.1 7.1 3.4 11.3 3.4 11.3 0 20.6-9.2 20.6-20.4C46 13.1 36.8 4 25.4 4zm12.4 25.9c-.2-.2-.6-.4-1.2-.7-.6-.3-3.5-1.7-4.1-1.9-.6-.2-1-.3-1.4.3-.4.6-1.5 1.9-1.9 2.3-.3.4-.7.4-1.3.2-.6-.3-2.5-.9-4.8-3-1.8-1.6-3-3.5-3.3-4.1-.4-.6 0-.9.3-1.2.3-.3.6-.7.9-1 .3-.3.4-.6.6-1 .2-.4.1-.7-.1-1-.1-.3-1.3-3.2-1.8-4.4-.5-1.2-1-1-1.3-1h-1.1c-.4 0-1 .1-1.6.7s-2.1 2-2.1 5c0 2.9 2.1 5.8 2.4 6.2.3.4 4.1 6.6 10.2 9 6.1 2.4 6.1 1.6 7.2 1.5 1.1-.1 3.5-1.4 4-2.8.6-1.6.6-2.8.4-3.1z","fill":"#fff"}})])
          )
        }
      }
    